module.exports = __webpack_public_path__ + "media/images/slider_img_sp_02-74283dd739fa2beeea7f7eca975a16a4.png";